import React from "react";
import HelpAndSupportTemplate from "./HelpAndSupportTemplate";
import { useMediaQuery } from 'react-responsive';

const HelpAndSupport = () => {
  const smallScreens = useMediaQuery({ maxWidth: 639});

  return (
    <HelpAndSupportTemplate>
      <section>
        <h1 className="a-one-paturegular fs-40">Help & Support</h1>
        <p>We're here to help with your API and answer your needs.</p>
      </section>

      {
        !smallScreens && 
        <section className="grid-col-12">
          <div className="grid-row grid-gap flex-justify-center">
            <div className="display-none tablet:display-block grid-col-4"></div>
            <div className="grid-col-8 mt--30">
              <div className="flex xl-gap">
                <div className="box-container">
                  <a className="no-decor" href="https://servicedesk.cdc.gov/esc?id=sc_cat_item&table=sc_cat_item&sys_id=6c00be721be286d06aa6ece2604bcb33" target="_blank" rel="noreferrer">
                    <div className="flex col sb m-gap box-container-content">
                      <div className="page-title box-title fs-30">CDC Support</div>
                      <p>Requires CDC credentials to access: Recommended for CDC employees, contractors, or a user with a SAMS ID.</p>
                    </div>
                  </a>
                </div>
                <div className="box-container">
                  <a className="no-decor" href="/support-ticket/submit-support-ticket" target="_blank" rel="noreferrer">
                    <div className="flex col sb m-gap box-container-content">
                      <div className="page-title box-title fs-30">Register for Access</div>
                      <p>External users outside of the CDC without SAMS or CDC credentials can register for access with Digital Gateway.</p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="long-box-container mt-30">
                <a className="no-decor" href="/help/faq" target="_blank" rel="noreferrer">
                  <div className="flex col box-container-content">
                    <div className="page-title box-title fs-30">FAQ</div>
                    <p>Find answers to commonly asked questions about Digital Gateway.</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      }

      {
        smallScreens && 
        <section className="flex col m-gap">
          <div className="box-container w-100">
            <a className="no-decor" href="https://servicedesk.cdc.gov/esc?id=sc_cat_item&table=sc_cat_item&sys_id=6c00be721be286d06aa6ece2604bcb33" target="_blank" rel="noreferrer">
              <div className="flex col sb m-gap box-container-content">
                <div className="page-title box-title fs-25">CDC Support</div>
                <p>Requires CDC credentials to access: Recommended for CDC employees, contractors, or a user with a SAMS ID.</p>
              </div>
            </a>
          </div>
          <div className="box-container w-100">
            <a className="no-decor" href="/support-ticket/submit-support-ticket" target="_blank" rel="noreferrer">
              <div className="flex col sb m-gap box-container-content">
                <div className="page-title box-title fs-25">Register for Access</div>
                <p>External users outside of the CDC without SAMS or CDC credentials can register for access with Digital Gateway.</p>
              </div>
            </a>
          </div>
          <div className="box-container w-100">
            <a className="no-decor" href="/help/faq" target="_blank" rel="noreferrer">
              <div className="flex col sb m-gap box-container-content">
                <div className="page-title box-title fs-25">FAQ</div>
                <p>Find answers to commonly asked questions about Digital Gateway.</p>
              </div>
            </a>
          </div>
        </section>
      }

    </HelpAndSupportTemplate>

  )
}

export default HelpAndSupport;
